'use client';
import { useState, useEffect } from 'react';
 import Link from'next/link';
import { usePathname } from 'next/navigation';
 import Icon from'@/components/ui/AppIcon';
 

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const navLinks = [
    { id: 'nav_home', label: 'Home', href: '/homepage' },
    { id: 'nav_booking', label: 'Book a Scooter', href: '/booking' },
    { id: 'nav_safety', label: 'Safety', href: '/homepage#safety' },
    { id: 'nav_support', label: 'Support', href: '/homepage#support' },
  ]

  const isActive = (href: string) => {
    if (href.includes('#')) {
      return pathname === href.split('#')[0]
    }
    return pathname === href
  }

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-md'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link href="/homepage" className="flex items-center gap-3 group">
            <div className="relative w-10 h-10 rounded-full bg-gradient-to-br from-primary to-secondary shadow-lg group-hover:scale-105 transition-transform">
              <Icon
                name="BoltIcon"
                variant="solid"
                size={24}
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white"
              />
            </div>
            <div className="flex flex-col">
              <span className="text-xl font-display font-bold text-primary">
                ScootRide
              </span>
              <span className="text-xs text-muted-foreground -mt-1">
                Ride Electric, Ride Smart
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.id}
                href={link.href}
                className={`text-sm font-body font-medium transition-colors relative ${
                  isActive(link.href)
                    ? 'text-primary' :'text-foreground/70 hover:text-primary'
                }`}
              >
                {link.label}
                {isActive(link.href) && (
                  <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-accent rounded-full" />
                )}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <Link
              href="/booking"
              className="btn-primary inline-flex items-center gap-2"
            >
              <Icon name="CalendarIcon" size={18} />
              Book Scooter
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-muted transition-colors"
            aria-label="Toggle mobile menu"
          >
            <Icon
              name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'}
              size={24}
              className="text-foreground"
            />
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-6 border-t border-border bg-white/95 backdrop-blur-md">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.id}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`text-base font-body font-medium px-4 py-2 rounded-lg transition-colors ${
                    isActive(link.href)
                      ? 'bg-accent/10 text-primary' :'text-foreground/70 hover:bg-muted'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                href="/booking"
                onClick={() => setIsMobileMenuOpen(false)}
                className="btn-primary inline-flex items-center justify-center gap-2 mx-4"
              >
                <Icon name="CalendarIcon" size={18} />
                Book Scooter
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  )
}